const colors = {
  1: '#00b480',
  2: '#4cbd90',
  3: '#7dc8a1',
  4: '#bbded3',
  5: '#77c1d0',
  6: '#0097ae',
  7: '#008ea5',
  8: '#007490'
}

const coloringRanges = [
  { startValue: 10.1, endValue: 11, style: '' },
  { startValue: 9.0, endValue: 9.99, color: '#009800', style: 'green' },
  { startValue: 7.0, endValue: 8.99, color: '#99ff33', style: 'yellow-green' },
  { startValue: 5.0, endValue: 6.99, color: '#faf300', style: 'yellow' },
  { startValue: 3.0, endValue: 4.99, color: '#ffc000', style: 'orange' },
  { startValue: 0.0, endValue: 2.99, color: '#ff0000', style: 'red' },
  { startValue: -1.1, endValue: -0.01, color: '#bfbfbf', style: 'grey' },
]

const getBackgroundClass = value => {
  let style
  if (value === null || value === undefined) { 
    style = coloringRanges[coloringRanges.length - 1].style
  }
  else {
    for (const i in coloringRanges) {
      if (value >= coloringRanges[i].startValue) {
        style = coloringRanges[i].style
        break
      }
    }
  }
  return style ? `badge-${style}` : ''
}

const getBackgroundColor = value => {
  let color
  if (value === null || value === undefined) { 
    color = coloringRanges[coloringRanges.length - 1].color
  }
  else {
    for (const i in coloringRanges) {
      if (value >= coloringRanges[i].startValue) {
        color = coloringRanges[i].color
        break
      }
    }
  }
  return color ? color : ''
}

const getSliderGradient = (low, high) => {
  const args = []
  if (low < 0 && high > 10) {
    args.push('#bfbfbf')
    args.push('#bfbfbf')
  } else if (low < 0) {
    args.push(getBackgroundColor(high))
    args.push('#bfbfbf')
  } else if (high > 10) {
    args.push('#bfbfbf')
    args.push(getBackgroundColor(low))
  } else {
    for (const i in coloringRanges) {
      if (low <= coloringRanges[i].endValue && coloringRanges[i].startValue <= high) {
        args.push(coloringRanges[i].color)
      }
    }
  }
  args.push('90deg')
  const val = `linear-gradient(${args.reverse().join(',')} 100%)`
  return val
}

export {
  colors,
  getBackgroundColor,
  getBackgroundClass,
  getSliderGradient
}